// import React, { useState } from "react";
// import {
//   Grid,
//   Typography,
//   Box,
//   Button,
//   Container,
//   Card,
//   CardContent,
//   useTheme,
//   Fade,
//   Slide,
//   Chip,
//   AppBar,
//   IconButton,
//   Stack,
//   alpha,
//   Stepper,
//   Step,
//   StepLabel,
//   StepContent,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Paper
// } from "@mui/material";
// import {
//   Home as HomeIcon,
//   Work as WorkIcon,
//   Schedule as ScheduleIcon,
//   Security as SecurityIcon,
//   Star as StarIcon,
//   CleaningServices as CleaningServicesIcon,
//   Payment as PaymentIcon,
//   SupportAgent as SupportIcon,
//   Groups as GroupsIcon,
//   ArrowForward as ArrowForwardIcon,
//   CheckCircle as CheckCircleIcon,
//   Menu as MenuIcon,
//   Close as CloseIcon,
//   PhoneIphone as MobileIcon,
//   QrCode2 as QRIcon,
//   FormatQuote as QuoteIcon,
//   Apple as AppleIcon,
//   ChevronLeft as ChevronLeftIcon,
//   ChevronRight as ChevronRightIcon,
//   AccountCircle as AccountIcon,
//   CalendarToday as CalendarIcon,
//   AttachMoney as MoneyIcon,
//   LocationOn as LocationIcon,
//   EmojiEvents as AwardIcon,
//   School as TrainingIcon,
//   Shield as ShieldIcon,
//   People as TeamIcon,
//   TrendingUp as GrowthIcon
// } from "@mui/icons-material";
// import { keyframes } from "@mui/system";

// // Animations
// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px); }
//   50% { transform: translateY(-4px); }
// `;

// const pulseAnimation = keyframes`
//   0%, 100% { transform: scale(1); }
//   50% { transform: scale(1.05); }
// `;

// const CleanerHome = () => {
//   const theme = useTheme();
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [activeStep, setActiveStep] = useState(0);
//   const [applicationForm, setApplicationForm] = useState({
//     fullName: "",
//     email: "",
//     phone: "",
//     experience: "",
//     location: "",
//     availability: ""
//   });

//   // Stats for cleaners
//   const cleanerStats = [
//     { number: "$35-50", label: "Per Hour" },
//     { number: "500+", label: "Active Cleaners" },
//     { number: "4.8★", label: "Cleaner Rating" },
//     { number: "95%", label: "Work Satisfaction" }
//   ];

//   // Benefits for cleaners
//   const benefits = [
//     {
//       icon: <MoneyIcon sx={{ fontSize: 40 }} />,
//       title: "Competitive Pay",
//       description: "Earn $35-50 per hour with tips and bonuses"
//     },
//     {
//       icon: <CalendarIcon sx={{ fontSize: 40 }} />,
//       title: "Flexible Schedule",
//       description: "Choose your own hours and work when you want"
//     },
//     {
//       icon: <TrainingIcon sx={{ fontSize: 40 }} />,
//       title: "Free Training",
//       description: "Comprehensive training and ongoing support"
//     },
//     {
//       icon: <ShieldIcon sx={{ fontSize: 40 }} />,
//       title: "Insurance Coverage",
//       description: "Liability insurance for your peace of mind"
//     },
//     {
//       icon: <TeamIcon sx={{ fontSize: 40 }} />,
//       title: "Support Team",
//       description: "Dedicated support team available 24/7"
//     },
//     {
//       icon: <GrowthIcon sx={{ fontSize: 40 }} />,
//       title: "Career Growth",
//       description: "Opportunities to grow into team lead positions"
//     }
//   ];

//   // How it works steps
//   const steps = [
//     {
//       label: "Apply Online",
//       description: "Fill out our simple application form in 5 minutes",
//       icon: "📝"
//     },
//     {
//       label: "Background Check",
//       description: "Quick and secure background verification",
//       icon: "🔍"
//     },
//     {
//       label: "Training & Onboarding",
//       description: "Complete our free online training program",
//       icon: "🎓"
//     },
//     {
//       label: "Start Working",
//       description: "Accept cleaning jobs and start earning immediately",
//       icon: "💼"
//     }
//   ];

//   // Testimonials from existing cleaners
//   const cleanerTestimonials = [
//     {
//       id: 1,
//       name: "Maria Rodriguez",
//       role: "Professional Cleaner",
//       location: "Miami, FL",
//       rating: 5,
//       comment: "I've been cleaning with FreshSweeper for over a year and it's changed my life. The flexible schedule lets me pick up my kids from school, and I'm earning more than I ever did at my previous job.",
//       avatar: "MR",
//       earnings: "$45/hr average"
//     },
//     {
//       id: 2,
//       name: "James Wilson",
//       role: "Cleaning Team Lead",
//       location: "Austin, TX",
//       rating: 5,
//       comment: "The support from FreshSweeper is incredible. They handle all the client communication and scheduling, so I can focus on what I do best - cleaning!",
//       avatar: "JW",
//       earnings: "$52/hr average"
//     },
//     {
//       id: 3,
//       name: "Sarah Chen",
//       role: "Professional Cleaner",
//       location: "San Diego, CA",
//       rating: 5,
//       comment: "I love being my own boss while still having the security of consistent work. The app makes it so easy to manage my schedule and track my earnings.",
//       avatar: "SC",
//       earnings: "$48/hr average"
//     }
//   ];

//   // Requirements to become a cleaner
//   const requirements = [
//     {
//       icon: "🔞",
//       title: "18+ Years Old",
//       description: "Must be at least 18 years of age"
//     },
//     {
//       icon: "🇺🇸",
//       title: "Work Authorization",
//       description: "Legal right to work in the United States"
//     },
//     {
//       icon: "📱",
//       title: "Smartphone",
//       description: "iPhone or Android with app compatibility"
//     },
//     {
//       icon: "🚗",
//       title: "Reliable Transportation",
//       description: "Ability to travel to cleaning locations"
//     },
//     {
//       icon: "💼",
//       title: "Cleaning Experience",
//       description: "Previous cleaning experience preferred"
//     },
//     {
//       icon: "⭐",
//       title: "Great Attitude",
//       description: "Professional and customer-focused approach"
//     }
//   ];

//   const handleNext = () => {
//     setActiveStep((prev) => prev + 1);
//   };

//   const handleBack = () => {
//     setActiveStep((prev) => prev - 1);
//   };

//   const handleFormChange = (field, value) => {
//     setApplicationForm(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   const handleSubmitApplication = () => {
//     // Handle form submission
//     console.log("Application submitted:", applicationForm);
//     // You would typically send this to your backend
//     alert("Application submitted successfully! We'll be in touch soon.");
//   };

//   return (
//     <Box sx={{ overflow: "hidden", background: theme.palette.background.default }}>
//       {/* Navigation */}
      

//       {/* Hero Section */}
//       <Box sx={{ pt: 12, pb: 8, background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)` }}>
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={800}>
//                 <Box sx={{ color: theme.palette.primary.contrastText }}>
//                   <Chip 
//                     label="💼 Join Our Team" 
//                     sx={{ 
//                       mb: 3,
//                       background: alpha(theme.palette.primary.contrastText, 0.2),
//                       color: theme.palette.primary.contrastText,
//                       fontWeight: 600,
//                       fontSize: "0.85rem",
//                       backdropFilter: "blur(10px)"
//                     }}
//                   />
                  
//                   <Typography
//                     variant="h1"
//                     sx={{
//                       fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
//                       fontWeight: 700,
//                       lineHeight: 1.1,
//                       mb: 2
//                     }}
//                   >
//                     Become a
//                     <Box
//                       component="span"
//                       sx={{
//                         color: theme.palette.secondary.main,
//                         display: "block"
//                       }}
//                     >
//                       Professional Cleaner
//                     </Box>
//                   </Typography>
                  
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mb: 4,
//                       fontSize: "1.1rem",
//                       lineHeight: 1.6,
//                       fontWeight: 400,
//                       opacity: 0.9
//                     }}
//                   >
//                     Join FreshSweeper and earn great money with flexible hours. 
//                     Be your own boss while we handle the clients, scheduling, and payments.
//                   </Typography>

//                   <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 6 }}>
//                     <Button
//                       variant="contained"
//                       size="large"
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         background: alpha(theme.palette.primary.contrastText, 0.2),
//                         backdropFilter: "blur(10px)",
//                         borderRadius: "8px",
//                         border: `1px solid ${alpha(theme.palette.primary.contrastText, 0.3)}`,
//                         fontWeight: 600,
//                         color: theme.palette.primary.contrastText,
//                         "&:hover": {
//                           background: alpha(theme.palette.primary.contrastText, 0.3),
//                           transform: "translateY(-1px)",
//                         },
//                         transition: "all 0.3s ease"
//                       }}
//                       onClick={() => document.getElementById('application-section').scrollIntoView({ behavior: 'smooth' })}
//                     >
//                       Start Your Application
//                     </Button>
                    
//                     <Button
//                       variant="outlined"
//                       size="large"
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderColor: theme.palette.primary.contrastText,
//                         color: theme.palette.primary.contrastText,
//                         borderRadius: "8px",
//                         "&:hover": {
//                           background: alpha(theme.palette.primary.contrastText, 0.1),
//                         }
//                       }}
//                     >
//                       View Earnings
//                     </Button>
//                   </Stack>

//                   {/* Stats */}
//                   <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
//                     {cleanerStats.map((stat, index) => (
//                       <Box key={index}>
//                         <Typography variant="h5" fontWeight="700" sx={{ opacity: 0.9 }}>
//                           {stat.number}
//                         </Typography>
//                         <Typography variant="body2" sx={{ opacity: 0.8, fontWeight: "500" }}>
//                           {stat.label}
//                         </Typography>
//                       </Box>
//                     ))}
//                   </Box>
//                 </Box>
//               </Fade>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Slide in timeout={1000} direction="left">
//                 <Box
//                   sx={{
//                     position: "relative",
//                     animation: `${floatAnimation} 6s ease-in-out infinite`
//                   }}
//                 >
//                   <Card
//                     sx={{
//                       background: alpha(theme.palette.background.paper, 0.1),
//                       backdropFilter: "blur(20px)",
//                       borderRadius: "16px",
//                       p: 4,
//                       boxShadow: "0 20px 60px rgba(0, 0, 0, 0.2)",
//                       border: `1px solid ${alpha(theme.palette.primary.contrastText, 0.2)}`,
//                       color: theme.palette.primary.contrastText
//                     }}
//                   >
//                     <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
//                       Why Clean with FreshSweeper?
//                     </Typography>
                    
//                     <Stack spacing={2}>
//                       {[
//                         { icon: "💵", text: "Earn $35-50 per hour" },
//                         { icon: "📅", text: "Choose your own schedule" },
//                         { icon: "🛡️", text: "Liability insurance included" },
//                         { icon: "🎓", text: "Free training provided" },
//                         { icon: "⭐", text: "Keep 100% of your tips" }
//                       ].map((item, index) => (
//                         <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                           <Box
//                             sx={{
//                               width: 40,
//                               height: 40,
//                               borderRadius: "8px",
//                               background: alpha(theme.palette.primary.contrastText, 0.2),
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               fontWeight: "bold",
//                               fontSize: "1.1rem"
//                             }}
//                           >
//                             {item.icon}
//                           </Box>
//                           <Typography variant="body1" fontWeight="500">
//                             {item.text}
//                           </Typography>
//                         </Box>
//                       ))}
//                     </Stack>
//                   </Card>
//                 </Box>
//               </Slide>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* Benefits Section */}
//       <Box sx={{ py: 10, background: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 700,
//                 color: theme.palette.text.primary,
//                 mb: 2,
//                 fontSize: { xs: "2.25rem", md: "2.75rem" }
//               }}
//             >
//               Why Choose FreshSweeper?
//             </Typography>
//             <Typography variant="h6" sx={{ color: theme.palette.text.secondary, maxWidth: "600px", mx: "auto" }}>
//               We provide everything you need to build a successful cleaning business
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {benefits.map((benefit, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>
//                 <Card
//                   sx={{
//                     height: "100%",
//                     background: theme.palette.background.paper,
//                     borderRadius: "16px",
//                     p: 4,
//                     boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
//                     border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//                     transition: "all 0.3s ease",
//                     textAlign: "center",
//                     "&:hover": {
//                       transform: "translateY(-8px)",
//                       boxShadow: "0 16px 48px rgba(0, 0, 0, 0.12)",
//                     }
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       width: 80,
//                       height: 80,
//                       borderRadius: "20px",
//                       background: alpha(theme.palette.primary.main, 0.1),
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       color: theme.palette.primary.main,
//                       margin: "0 auto 24px",
//                       animation: `${pulseAnimation} 2s ease-in-out infinite`
//                     }}
//                   >
//                     {benefit.icon}
//                   </Box>
//                   <Typography variant="h5" fontWeight="600" color={theme.palette.text.primary} gutterBottom>
//                     {benefit.title}
//                   </Typography>
//                   <Typography variant="body1" color={theme.palette.text.secondary}>
//                     {benefit.description}
//                   </Typography>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* How It Works Section */}
//       <Box sx={{ py: 12, background: theme.palette.background.default }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 700,
//                 color: theme.palette.text.primary,
//                 mb: 2,
//                 fontSize: { xs: "2.25rem", md: "2.75rem" }
//               }}
//             >
//               How to Get Started
//             </Typography>
//             <Typography variant="h6" sx={{ color: theme.palette.text.secondary, maxWidth: "600px", mx: "auto" }}>
//               Start earning in as little as one week
//             </Typography>
//           </Box>

//           <Box sx={{ maxWidth: 800, mx: 'auto' }}>
//             <Stepper activeStep={activeStep} orientation="vertical">
//               {steps.map((step, index) => (
//                 <Step key={step.label}>
//                   <StepLabel
//                     StepIconComponent={() => (
//                       <Box
//                         sx={{
//                           width: 40,
//                           height: 40,
//                           borderRadius: "12px",
//                           background: theme.palette.primary.main,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           color: theme.palette.primary.contrastText,
//                           fontWeight: "bold",
//                           fontSize: "1.2rem"
//                         }}
//                       >
//                         {step.icon}
//                       </Box>
//                     )}
//                   >
//                     <Typography variant="h6" fontWeight="600" color={theme.palette.text.primary}>
//                       {step.label}
//                     </Typography>
//                   </StepLabel>
//                   <StepContent>
//                     <Typography variant="body1" color={theme.palette.text.secondary} sx={{ mb: 2 }}>
//                       {step.description}
//                     </Typography>
//                     <Box sx={{ mb: 2 }}>
//                       <Button
//                         variant="contained"
//                         onClick={handleNext}
//                         sx={{ mr: 1 }}
//                       >
//                         {index === steps.length - 1 ? 'Finish' : 'Continue'}
//                       </Button>
//                       <Button
//                         disabled={index === 0}
//                         onClick={handleBack}
//                       >
//                         Back
//                       </Button>
//                     </Box>
//                   </StepContent>
//                 </Step>
//               ))}
//             </Stepper>
//           </Box>
//         </Container>
//       </Box>

//       {/* Requirements Section */}
//       <Box sx={{ py: 10, background: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 700,
//                 color: theme.palette.text.primary,
//                 mb: 2,
//                 fontSize: { xs: "2.25rem", md: "2.75rem" }
//               }}
//             >
//               Requirements to Join
//             </Typography>
//             <Typography variant="h6" sx={{ color: theme.palette.text.secondary, maxWidth: "600px", mx: "auto" }}>
//               Here's what you need to get started
//             </Typography>
//           </Box>

//           <Grid container spacing={3}>
//             {requirements.map((requirement, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>
//                 <Card
//                   sx={{
//                     background: theme.palette.background.paper,
//                     borderRadius: "12px",
//                     p: 3,
//                     boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
//                     border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//                     textAlign: "center",
//                     transition: "all 0.3s ease",
//                     "&:hover": {
//                       transform: "translateY(-4px)",
//                       boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
//                     }
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       width: 60,
//                       height: 60,
//                       borderRadius: "12px",
//                       background: alpha(theme.palette.primary.main, 0.1),
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       color: theme.palette.primary.main,
//                       fontWeight: "bold",
//                       fontSize: "1.5rem",
//                       margin: "0 auto 16px"
//                     }}
//                   >
//                     {requirement.icon}
//                   </Box>
//                   <Typography variant="h6" fontWeight="600" color={theme.palette.text.primary} gutterBottom>
//                     {requirement.title}
//                   </Typography>
//                   <Typography variant="body2" color={theme.palette.text.secondary}>
//                     {requirement.description}
//                   </Typography>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* Cleaner Testimonials */}
//       <Box sx={{ py: 12, background: theme.palette.background.default }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip 
//               label="👥 From Our Team" 
//               sx={{ 
//                 mb: 3,
//                 background: alpha(theme.palette.primary.main, 0.1),
//                 color: theme.palette.primary.dark,
//                 fontWeight: 600,
//                 fontSize: "0.85rem"
//               }}
//             />
            
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 700,
//                 color: theme.palette.text.primary,
//                 mb: 2,
//                 fontSize: { xs: "2.25rem", md: "2.75rem" }
//               }}
//             >
//               Hear From Our Cleaners
//             </Typography>
//             <Typography variant="h6" sx={{ color: theme.palette.text.secondary, maxWidth: "600px", mx: "auto" }}>
//               Real stories from cleaners who built successful careers with FreshSweeper
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {cleanerTestimonials.map((testimonial, index) => (
//               <Grid item xs={12} md={4} key={testimonial.id}>
//                 <Fade in timeout={800 + index * 200}>
//                   <Card
//                     sx={{
//                       height: "100%",
//                       background: theme.palette.background.paper,
//                       borderRadius: "16px",
//                       p: 4,
//                       boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
//                       border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//                       transition: "all 0.3s ease",
//                       "&:hover": {
//                         transform: "translateY(-4px)",
//                         boxShadow: "0 12px 40px rgba(0, 0, 0, 0.12)",
//                       }
//                     }}
//                   >
//                     <QuoteIcon 
//                       sx={{ 
//                         fontSize: 40, 
//                         color: alpha(theme.palette.primary.main, 0.2),
//                         mb: 2 
//                       }} 
//                     />
                    
//                     <Box sx={{ display: "flex", mb: 2 }}>
//                       {[...Array(5)].map((_, i) => (
//                         <StarIcon 
//                           key={i} 
//                           sx={{ 
//                             color: i < testimonial.rating ? theme.palette.secondary.main : theme.palette.grey[300],
//                             fontSize: 20
//                           }} 
//                         />
//                       ))}
//                     </Box>
                    
//                     <Typography 
//                       variant="body1" 
//                       sx={{ 
//                         color: theme.palette.text.primary, 
//                         mb: 3,
//                         fontSize: "1.1rem",
//                         lineHeight: 1.6,
//                         fontStyle: "italic"
//                       }}
//                     >
//                       "{testimonial.comment}"
//                     </Typography>
                    
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                       <Box
//                         sx={{
//                           width: 50,
//                           height: 50,
//                           borderRadius: "12px",
//                           background: alpha(theme.palette.primary.main, 0.1),
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           color: theme.palette.primary.main,
//                           fontWeight: "bold",
//                           fontSize: "1rem"
//                         }}
//                       >
//                         {testimonial.avatar}
//                       </Box>
                      
//                       <Box>
//                         <Typography variant="h6" fontWeight="600" color={theme.palette.text.primary}>
//                           {testimonial.name}
//                         </Typography>
//                         <Typography variant="body2" color={theme.palette.text.secondary}>
//                           {testimonial.role}
//                         </Typography>
//                         <Typography variant="caption" color={theme.palette.text.secondary}>
//                           {testimonial.location} • {testimonial.earnings}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </Card>
//                 </Fade>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* Application Form Section */}
//       <Box id="application-section" sx={{ py: 12, background: theme.palette.background.paper }}>
//         <Container maxWidth="md">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 700,
//                 color: theme.palette.text.primary,
//                 mb: 2,
//                 fontSize: { xs: "2.25rem", md: "2.75rem" }
//               }}
//             >
//               Start Your Application
//             </Typography>
//             <Typography variant="h6" sx={{ color: theme.palette.text.secondary, maxWidth: "600px", mx: "auto" }}>
//               Join our team of professional cleaners. It only takes 5 minutes to apply.
//             </Typography>
//           </Box>

//           <Card
//             sx={{
//               background: theme.palette.background.paper,
//               borderRadius: "16px",
//               p: 4,
//               boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
//               border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`
//             }}
//           >
//             <Grid container spacing={3}>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Full Name"
//                   value={applicationForm.fullName}
//                   onChange={(e) => handleFormChange('fullName', e.target.value)}
//                   variant="outlined"
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Email Address"
//                   type="email"
//                   value={applicationForm.email}
//                   onChange={(e) => handleFormChange('email', e.target.value)}
//                   variant="outlined"
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Phone Number"
//                   value={applicationForm.phone}
//                   onChange={(e) => handleFormChange('phone', e.target.value)}
//                   variant="outlined"
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>Cleaning Experience</InputLabel>
//                   <Select
//                     value={applicationForm.experience}
//                     label="Cleaning Experience"
//                     onChange={(e) => handleFormChange('experience', e.target.value)}
//                   >
//                     <MenuItem value="none">No experience</MenuItem>
//                     <MenuItem value="1-2">1-2 years</MenuItem>
//                     <MenuItem value="3-5">3-5 years</MenuItem>
//                     <MenuItem value="5+">5+ years</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="City & State"
//                   value={applicationForm.location}
//                   onChange={(e) => handleFormChange('location', e.target.value)}
//                   variant="outlined"
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>Availability</InputLabel>
//                   <Select
//                     value={applicationForm.availability}
//                     label="Availability"
//                     onChange={(e) => handleFormChange('availability', e.target.value)}
//                   >
//                     <MenuItem value="full-time">Full-time</MenuItem>
//                     <MenuItem value="part-time">Part-time</MenuItem>
//                     <MenuItem value="weekends">Weekends only</MenuItem>
//                     <MenuItem value="flexible">Flexible</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}>
//                 <Button
//                   variant="contained"
//                   size="large"
//                   fullWidth
//                   sx={{
//                     py: 2,
//                     fontSize: "1.1rem",
//                     background: theme.palette.primary.main,
//                     borderRadius: "8px",
//                     fontWeight: 600,
//                     "&:hover": {
//                       transform: "translateY(-1px)",
//                       boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.4)}`,
//                     },
//                     transition: "all 0.3s ease"
//                   }}
//                   onClick={handleSubmitApplication}
//                 >
//                   Submit Application
//                 </Button>
//                 <Typography variant="body2" color={theme.palette.text.secondary} sx={{ textAlign: 'center', mt: 2 }}>
//                   We'll contact you within 24 hours to discuss next steps
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Card>
//         </Container>
//       </Box>

//       {/* Final CTA */}
//       <Box sx={{ py: 12, background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)` }}>
//         <Container maxWidth="md">
//           <Box sx={{ textAlign: "center", color: theme.palette.primary.contrastText }}>
//             <CleaningServicesIcon sx={{ fontSize: 60, mb: 3, opacity: 0.9 }} />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 700,
//                 mb: 3,
//                 fontSize: { xs: "2.25rem", md: "2.75rem" }
//               }}
//             >
//               Ready to Start Your Cleaning Career?
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 mb: 4,
//                 opacity: 0.9,
//                 fontSize: "1.1rem",
//                 maxWidth: "600px",
//                 mx: "auto"
//               }}
//             >
//               Join thousands of cleaners who have built successful businesses with FreshSweeper. 
//               Flexible hours, great pay, and full support.
//             </Typography>
            
//             <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
//               <Button
//                 variant="contained"
//                 size="large"
//                 sx={{
//                   px: 4,
//                   py: 2,
//                   fontSize: "1.1rem",
//                   background: alpha(theme.palette.primary.contrastText, 0.2),
//                   backdropFilter: "blur(10px)",
//                   borderRadius: "8px",
//                   border: `1px solid ${alpha(theme.palette.primary.contrastText, 0.3)}`,
//                   fontWeight: 600,
//                   color: theme.palette.primary.contrastText,
//                   "&:hover": {
//                     background: alpha(theme.palette.primary.contrastText, 0.3),
//                     transform: "translateY(-1px)"
//                   },
//                   transition: "all 0.3s ease"
//                 }}
//                 onClick={() => document.getElementById('application-section').scrollIntoView({ behavior: 'smooth' })}
//               >
//                 Apply Now
//               </Button>
              
//               <Button
//                 variant="outlined"
//                 size="large"
//                 sx={{
//                   px: 4,
//                   py: 2,
//                   fontSize: "1.1rem",
//                   borderColor: theme.palette.primary.contrastText,
//                   color: theme.palette.primary.contrastText,
//                   borderRadius: "8px",
//                   "&:hover": {
//                     background: alpha(theme.palette.primary.contrastText, 0.1),
//                   }
//                 }}
//               >
//                 Contact Support
//               </Button>
//             </Stack>
//           </Box>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default CleanerHome;




// import React, { useState, useRef, useEffect } from "react";
// import {
//   Grid,
//   Typography,
//   Box,
//   Button,
//   Container,
//   Card,
//   CardContent,
//   useTheme,
//   Fade,
//   Chip,
//   Stack,
//   alpha,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Paper,
//   Avatar,
//   Rating,
//   Stepper,
//   Step,
//   StepLabel,
//   StepContent,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   LinearProgress,
//   Divider,
//   Zoom,
// } from "@mui/material";
// import { keyframes } from "@emotion/react";
// import {
//   CleaningServices as CleaningServicesIcon,
//   Schedule as ScheduleIcon,
//   Payment as PaymentIcon,
//   SupportAgent as SupportIcon,
//   Star as StarIcon,
//   CheckCircle as CheckCircleIcon,
//   PhoneIphone as MobileIcon,
//   FormatQuote as QuoteIcon,
//   AccountCircle as AccountIcon,
//   CalendarToday as CalendarIcon,
//   AttachMoney as MoneyIcon,
//   EmojiEvents as AwardIcon,
//   School as TrainingIcon,
//   Shield as ShieldIcon,
//   People as TeamIcon,
//   TrendingUp as GrowthIcon,
//   Close as CloseIcon,
//   ArrowForward as ArrowForwardIcon,
//   Work as WorkIcon,
//   Security as SecurityIcon,
//   Groups as GroupsIcon,
//   Apple as AppleIcon,
//   QrCode2 as QRIcon,
// } from "@mui/icons-material";

// // Animations
// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px); }
//   50% { transform: translateY(-8px); }
// `;

// const fadeInUp = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(30px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// const slideInLeft = keyframes`
//   from {
//     opacity: 0;
//     transform: translateX(-40px);
//   }
//   to {
//     opacity: 1;
//     transform: translateX(0);
//   }
// `;

// const slideInRight = keyframes`
//   from {
//     opacity: 0;
//     transform: translateX(40px);
//   }
//   to {
//     opacity: 1;
//     transform: translateX(0);
//   }
// `;

// const scaleIn = keyframes`
//   from {
//     opacity: 0;
//     transform: scale(0.95);
//   }
//   to {
//     opacity: 1;
//     transform: scale(1);
//   }
// `;

// const CleanerHome = () => {
//   const theme = useTheme();
//   const [activeStep, setActiveStep] = useState(0);
//   const [applicationDialogOpen, setApplicationDialogOpen] = useState(false);
//   const [formSubmitted, setFormSubmitted] = useState(false);
  
//   const [applicationForm, setApplicationForm] = useState({
//     fullName: "",
//     email: "",
//     phone: "",
//     experience: "",
//     location: "",
//     availability: ""
//   });

//   // Stats for cleaners
//   const cleanerStats = [
//     { number: "$35-50", label: "Per Hour", icon: <MoneyIcon />, color: "#10b981" },
//     { number: "500+", label: "Active Cleaners", icon: <TeamIcon />, color: "#3b82f6" },
//     { number: "4.9★", label: "Cleaner Rating", icon: <StarIcon />, color: "#f59e0b" },
//     { number: "2,500+", label: "Jobs/Week", icon: <WorkIcon />, color: "#8b5cf6" },
//   ];

//   // Benefits for cleaners
//   const benefits = [
//     {
//       icon: <MoneyIcon />,
//       title: "Competitive Pay",
//       description: "Earn $35-50 per hour with tips and bonuses. Weekly direct deposits.",
//       color: "#10b981",
//     },
//     {
//       icon: <CalendarIcon />,
//       title: "Flexible Schedule",
//       description: "Choose your own hours. Work when you want, take time off when you need.",
//       color: "#3b82f6",
//     },
//     {
//       icon: <TrainingIcon />,
//       title: "Free Training",
//       description: "Comprehensive training program. Learn professional cleaning techniques.",
//       color: "#8b5cf6",
//     },
//     {
//       icon: <ShieldIcon />,
//       title: "Insurance Coverage",
//       description: "Liability insurance included. Work with peace of mind.",
//       color: "#ef4444",
//     },
//     {
//       icon: <TeamIcon />,
//       title: "24/7 Support",
//       description: "Dedicated support team. Help whenever you need it.",
//       color: "#f59e0b",
//     },
//     {
//       icon: <GrowthIcon />,
//       title: "Career Growth",
//       description: "Opportunities to become team lead or mentor new cleaners.",
//       color: "#06b6d4",
//     },
//   ];

//   // How it works steps
//   const steps = [
//     {
//       label: "Apply Online",
//       description: "Fill out our simple application form in 5 minutes",
//       icon: "📝",
//       time: "5 minutes",
//     },
//     {
//       label: "Background Check",
//       description: "Quick and secure background verification",
//       icon: "🔍",
//       time: "24-48 hours",
//     },
//     {
//       label: "Training & Onboarding",
//       description: "Complete our free online training program",
//       icon: "🎓",
//       time: "2-3 hours",
//     },
//     {
//       label: "Start Working",
//       description: "Accept cleaning jobs and start earning immediately",
//       icon: "💼",
//       time: "Immediate",
//     },
//   ];

//   // Testimonials
//   const testimonials = [
//     {
//       name: "Maria Rodriguez",
//       role: "Top Rated Cleaner",
//       location: "Miami, FL",
//       rating: 5,
//       comment: "FreshSweeper changed my life. I set my own schedule, earn great money, and the support team is amazing. Best decision I ever made.",
//       avatar: "MR",
//       earnings: "$4,200/month",
//       image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
//     },
//     {
//       name: "James Wilson",
//       role: "Team Lead",
//       location: "Austin, TX",
//       rating: 5,
//       comment: "Been with FreshSweeper for 2 years. The pay is consistent, clients are great, and I've never felt more valued as a worker.",
//       avatar: "JW",
//       earnings: "$5,800/month",
//       image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
//     },
//     {
//       name: "Sarah Chen",
//       role: "Professional Cleaner",
//       location: "San Diego, CA",
//       rating: 5,
//       comment: "I love being my own boss. The app makes scheduling so easy, and I always get paid on time. Highly recommend!",
//       avatar: "SC",
//       earnings: "$4,500/month",
//       image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
//     },
//   ];

//   // Requirements
//   const requirements = [
//     { icon: "🔞", title: "18+ Years Old", description: "Must be at least 18 years of age" },
//     { icon: "🇺🇸", title: "Work Authorization", description: "Legal right to work in the US" },
//     { icon: "📱", title: "Smartphone", description: "iPhone or Android with app compatibility" },
//     { icon: "🚗", title: "Transportation", description: "Reliable transportation to job sites" },
//   ];

//   const handleNext = () => {
//     setActiveStep((prev) => prev + 1);
//   };

//   const handleBack = () => {
//     setActiveStep((prev) => prev - 1);
//   };

//   const handleFormChange = (field, value) => {
//     setApplicationForm(prev => ({ ...prev, [field]: value }));
//   };

//   const handleSubmitApplication = () => {
//     setFormSubmitted(true);
//     setTimeout(() => {
//       setApplicationDialogOpen(false);
//       setFormSubmitted(false);
//       setApplicationForm({
//         fullName: "",
//         email: "",
//         phone: "",
//         experience: "",
//         location: "",
//         availability: ""
//       });
//     }, 1500);
//   };

//   const openApplicationDialog = () => {
//     setApplicationDialogOpen(true);
//   };

//   const closeApplicationDialog = () => {
//     setApplicationDialogOpen(false);
//   };

//   return (
//     <Box sx={{ overflow: "hidden", bgcolor: theme.palette.background.default }}>
      
//       {/* ========== HERO SECTION - NO BLUE BANNER ========== */}
//       <Box
//         sx={{
//           position: "relative",
//           backgroundColor: "transparent",
//           pt: { xs: 6, md: 10 },
//           pb: { xs: 4, md: 6 },
//         }}
//       >
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             {/* Left Content */}
//             <Grid item xs={12} md={7}>
//               <Fade in timeout={800}>
//                 <Box sx={{ animation: `${slideInLeft} 0.6s ease-out` }}>
//                   <Chip
//                     label="💼 We're Hiring!"
//                     sx={{
//                       mb: 3,
//                       background: alpha(theme.palette.success.main, 0.1),
//                       color: theme.palette.success.main,
//                       fontWeight: 600,
//                       fontSize: "0.85rem",
//                     }}
//                   />

//                   <Typography
//                     variant="h1"
//                     sx={{
//                       fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
//                       fontWeight: 800,
//                       lineHeight: 1.1,
//                       mb: 2,
//                       color: theme.palette.text.primary,
//                     }}
//                   >
//                     Become a
//                     <Box component="span" sx={{ display: "block", color: theme.palette.primary.main }}>
//                       Professional Cleaner
//                     </Box>
//                   </Typography>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mb: 4,
//                       fontSize: "1.1rem",
//                       lineHeight: 1.6,
//                       color: theme.palette.text.secondary,
//                       maxWidth: "90%",
//                     }}
//                   >
//                     Join FreshSweeper and earn great money with flexible hours. 
//                     Be your own boss while we handle the clients, scheduling, and payments.
//                   </Typography>

//                   <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
//                     <Button
//                       variant="contained"
//                       size="large"
//                       startIcon={<ArrowForwardIcon />}
//                       onClick={openApplicationDialog}
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "50px",
//                         fontWeight: 700,
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       Start Application
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       size="large"
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "50px",
//                         fontWeight: 600,
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       View Earnings
//                     </Button>
//                   </Stack>

//                   {/* Stats */}
//                   <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap", mt: 6 }}>
//                     {cleanerStats.map((stat, index) => (
//                       <Box key={index} sx={{ textAlign: "center" }}>
//                         <Box
//                           sx={{
//                             width: 40,
//                             height: 40,
//                             borderRadius: "12px",
//                             bgcolor: alpha(stat.color, 0.1),
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             mx: "auto",
//                             mb: 1,
//                             color: stat.color,
//                           }}
//                         >
//                           {stat.icon}
//                         </Box>
//                         <Typography variant="h5" fontWeight="800" color={stat.color}>
//                           {stat.number}
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary">
//                           {stat.label}
//                         </Typography>
//                       </Box>
//                     ))}
//                   </Box>
//                 </Box>
//               </Fade>
//             </Grid>

//             {/* Right Content - Hero Image */}
//             <Grid item xs={12} md={5}>
//               <Fade in timeout={1000}>
//                 <Box sx={{ animation: `${slideInRight} 0.6s ease-out` }}>
//                   <Box
//                     sx={{
//                       position: "relative",
//                       animation: `${floatAnimation} 4s ease-in-out infinite`,
//                     }}
//                   >
//                     <Box
//                       component="img"
//                       src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=500&h=500&fit=crop"
//                       alt="Professional cleaner"
//                       sx={{
//                         width: "100%",
//                         maxWidth: 400,
//                         height: "auto",
//                         borderRadius: "30px",
//                         boxShadow: "0 30px 50px rgba(0,0,0,0.1)",
//                         display: "block",
//                         margin: "0 auto",
//                       }}
//                     />
//                     {/* Floating badge */}
//                     <Paper
//                       elevation={0}
//                       sx={{
//                         position: "absolute",
//                         bottom: -10,
//                         right: -10,
//                         p: 1.5,
//                         borderRadius: 3,
//                         bgcolor: "white",
//                         boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1,
//                       }}
//                     >
//                       <AwardIcon sx={{ color: theme.palette.warning.main }} />
//                       <Typography variant="body2" fontWeight="600">Top Rated</Typography>
//                     </Paper>
//                   </Box>
//                 </Box>
//               </Fade>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== WHY CHOOSE US SECTION ========== */}
//       <Box sx={{ py: 8, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 6 }}>
//             <Chip
//               label="✨ Why Cleaners Love Us"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.primary.main, 0.1),
//                 color: theme.palette.primary.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 fontSize: { xs: "2rem", md: "2.5rem" },
//                 mb: 2,
//               }}
//             >
//               Everything You Need to Succeed
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               We provide the tools, support, and opportunities to build a thriving cleaning business
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {benefits.map((benefit, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>
//                 <Zoom in timeout={500 + index * 100}>
//                   <Card
//                     sx={{
//                       height: "100%",
//                       borderRadius: 4,
//                       p: 3,
//                       transition: "all 0.3s ease",
//                       "&:hover": {
//                         transform: "translateY(-4px)",
//                         boxShadow: theme.shadows[8],
//                       },
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         width: 56,
//                         height: 56,
//                         borderRadius: "16px",
//                         bgcolor: alpha(benefit.color, 0.1),
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         mb: 2,
//                         color: benefit.color,
//                       }}
//                     >
//                       {React.cloneElement(benefit.icon, { sx: { fontSize: 28 } })}
//                     </Box>
//                     <Typography variant="h6" fontWeight="800" gutterBottom>
//                       {benefit.title}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {benefit.description}
//                     </Typography>
//                   </Card>
//                 </Zoom>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== HOW IT WORKS SECTION ========== */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 6 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 fontSize: { xs: "2rem", md: "2.5rem" },
//                 mb: 2,
//               }}
//             >
//               Get Started in 4 Easy Steps
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary" }}>
//               From application to earning - it takes less than a week
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {steps.map((step, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Zoom in timeout={400 + index * 100}>
//                   <Card
//                     sx={{
//                       p: 3,
//                       textAlign: "center",
//                       borderRadius: 3,
//                       height: "100%",
//                       transition: "transform 0.2s",
//                       "&:hover": { transform: "translateY(-4px)" },
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         width: 64,
//                         height: 64,
//                         borderRadius: "20px",
//                         bgcolor: alpha(theme.palette.primary.main, 0.1),
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         fontSize: "2rem",
//                         mx: "auto",
//                         mb: 2,
//                       }}
//                     >
//                       {step.icon}
//                     </Box>
//                     <Typography variant="h6" fontWeight="800" gutterBottom>
//                       {step.label}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//                       {step.description}
//                     </Typography>
//                     <Chip
//                       label={step.time}
//                       size="small"
//                       sx={{ bgcolor: alpha(theme.palette.primary.main, 0.1) }}
//                     />
//                   </Card>
//                 </Zoom>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== REQUIREMENTS SECTION ========== */}
//       <Box sx={{ py: 8, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Typography variant="h3" fontWeight="800" gutterBottom>
//                 What You Need to Join
//               </Typography>
//               <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
//                 We make it easy to get started. Here's everything you'll need:
//               </Typography>
//               <Grid container spacing={2}>
//                 {requirements.map((req, index) => (
//                   <Grid item xs={12} sm={6} key={index}>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                       <Box
//                         sx={{
//                           width: 48,
//                           height: 48,
//                           borderRadius: "12px",
//                           bgcolor: alpha(theme.palette.primary.main, 0.1),
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           fontSize: "1.5rem",
//                         }}
//                       >
//                         {req.icon}
//                       </Box>
//                       <Box>
//                         <Typography variant="subtitle2" fontWeight="700">
//                           {req.title}
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary">
//                           {req.description}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <Paper
//                 elevation={0}
//                 sx={{
//                   p: 4,
//                   borderRadius: 4,
//                   bgcolor: alpha(theme.palette.success.main, 0.05),
//                   border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
//                   textAlign: "center",
//                 }}
//               >
//                 <Typography variant="h2" sx={{ fontSize: "3rem", mb: 1 }}>✅</Typography>
//                 <Typography variant="h6" fontWeight="800" gutterBottom>
//                   Quick & Easy Application
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary" paragraph>
//                   Most applicants are approved within 48 hours
//                 </Typography>
//                 <Button
//                   variant="contained"
//                   onClick={openApplicationDialog}
//                   startIcon={<ArrowForwardIcon />}
//                   sx={{ borderRadius: "50px" }}
//                 >
//                   Apply Now - It's Free
//                 </Button>
//               </Paper>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== TESTIMONIALS SECTION ========== */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 6 }}>
//             <Chip
//               label="⭐ Hear From Our Team"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.secondary.main, 0.1),
//                 color: theme.palette.secondary.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 fontSize: { xs: "2rem", md: "2.5rem" },
//               }}
//             >
//               What Our Cleaners Say
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {testimonials.map((testimonial, index) => (
//               <Grid item xs={12} md={4} key={index}>
//                 <Fade in timeout={600 + index * 200}>
//                   <Card
//                     sx={{
//                       height: "100%",
//                       borderRadius: 4,
//                       p: 3,
//                       transition: "transform 0.2s",
//                       "&:hover": { transform: "translateY(-4px)" },
//                     }}
//                   >
//                     <Rating value={testimonial.rating} readOnly sx={{ mb: 2 }} />
//                     <QuoteIcon sx={{ fontSize: 32, color: alpha(theme.palette.primary.main, 0.2), mb: 2 }} />
//                     <Typography variant="body2" sx={{ mb: 3, fontStyle: "italic", lineHeight: 1.6 }}>
//                       "{testimonial.comment}"
//                     </Typography>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                       <Avatar
//                         src={testimonial.image}
//                         sx={{ width: 48, height: 48 }}
//                       />
//                       <Box>
//                         <Typography variant="subtitle2" fontWeight="800">
//                           {testimonial.name}
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary">
//                           {testimonial.role} • {testimonial.location}
//                         </Typography>
//                         <Typography variant="caption" color="success.main" fontWeight="600" display="block">
//                           {testimonial.earnings}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </Card>
//                 </Fade>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== FAQ SECTION ========== */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={5}>
//               <Typography variant="h3" fontWeight="800" gutterBottom>
//                 Frequently Asked Questions
//               </Typography>
//               <Typography variant="body1" color="text.secondary">
//                 Get answers to common questions about becoming a FreshSweeper cleaner.
//               </Typography>
//               <Button
//                 variant="outlined"
//                 sx={{ mt: 3, borderRadius: "50px" }}
//                 startIcon={<SupportIcon />}
//               >
//                 View All FAQs
//               </Button>
//             </Grid>
//             <Grid item xs={12} md={7}>
//               <Stack spacing={2}>
//                 {[
//                   { q: "How much can I earn?", a: "Our cleaners earn $35-50 per hour on average, plus tips and bonuses." },
//                   { q: "When do I get paid?", a: "Weekly direct deposits every Friday. No waiting periods." },
//                   { q: "Do I need my own supplies?", a: "We provide a starter kit. You can also use your own supplies." },
//                   { q: "Is training provided?", a: "Yes! Free online training and ongoing support." },
//                 ].map((faq, idx) => (
//                   <Paper key={idx} sx={{ p: 2, borderRadius: 2 }}>
//                     <Typography variant="subtitle2" fontWeight="700" gutterBottom>
//                       {faq.q}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {faq.a}
//                     </Typography>
//                   </Paper>
//                 ))}
//               </Stack>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== FINAL CTA ========== */}
//       <Box
//         sx={{
//           py: 10,
//           background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
//         }}
//       >
//         <Container maxWidth="md">
//           <Box sx={{ textAlign: "center", color: "white" }}>
//             <CleaningServicesIcon sx={{ fontSize: 56, mb: 2, opacity: 0.9 }} />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 3,
//                 fontSize: { xs: "2rem", md: "2.5rem" },
//               }}
//             >
//               Ready to Start Your Cleaning Career?
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 mb: 4,
//                 opacity: 0.9,
//                 maxWidth: "500px",
//                 mx: "auto",
//               }}
//             >
//               Join thousands of cleaners who are building successful careers with FreshSweeper.
//             </Typography>
//             <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
//               <Button
//                 variant="contained"
//                 size="large"
//                 startIcon={<ArrowForwardIcon />}
//                 onClick={openApplicationDialog}
//                 sx={{
//                   px: 5,
//                   py: 2,
//                   fontSize: "1.1rem",
//                   bgcolor: "white",
//                   color: theme.palette.primary.main,
//                   borderRadius: "50px",
//                   fontWeight: 700,
//                   "&:hover": {
//                     bgcolor: alpha(theme.palette.common.white, 0.9),
//                     transform: "translateY(-2px)",
//                   },
//                 }}
//               >
//                 Apply Now
//               </Button>
//               <Button
//                 variant="outlined"
//                 size="large"
//                 sx={{
//                   px: 5,
//                   py: 2,
//                   fontSize: "1.1rem",
//                   borderColor: "white",
//                   color: "white",
//                   borderRadius: "50px",
//                   fontWeight: 600,
//                   "&:hover": {
//                     bgcolor: alpha(theme.palette.common.white, 0.1),
//                     transform: "translateY(-2px)",
//                   },
//                 }}
//               >
//                 Learn More
//               </Button>
//             </Stack>
//           </Box>
//         </Container>
//       </Box>

//       {/* ========== APPLICATION DIALOG ========== */}
//       <Dialog
//         open={applicationDialogOpen}
//         onClose={closeApplicationDialog}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{ sx: { borderRadius: 3 } }}
//       >
//         <DialogTitle sx={{ borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
//           <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//             <Typography variant="h6" fontWeight="800">Start Your Application</Typography>
//             <IconButton onClick={closeApplicationDialog}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent sx={{ pt: 3 }}>
//           {formSubmitted ? (
//             <Box sx={{ textAlign: "center", py: 4 }}>
//               <CheckCircleIcon sx={{ fontSize: 64, color: theme.palette.success.main, mb: 2 }} />
//               <Typography variant="h6" fontWeight="800">Application Submitted!</Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Thank you for your interest. We'll contact you within 24 hours.
//               </Typography>
//             </Box>
//           ) : (
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Full Name"
//                   value={applicationForm.fullName}
//                   onChange={(e) => handleFormChange('fullName', e.target.value)}
//                   variant="outlined"
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Email Address"
//                   type="email"
//                   value={applicationForm.email}
//                   onChange={(e) => handleFormChange('email', e.target.value)}
//                   variant="outlined"
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Phone Number"
//                   value={applicationForm.phone}
//                   onChange={(e) => handleFormChange('phone', e.target.value)}
//                   variant="outlined"
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>Cleaning Experience</InputLabel>
//                   <Select
//                     value={applicationForm.experience}
//                     label="Cleaning Experience"
//                     onChange={(e) => handleFormChange('experience', e.target.value)}
//                   >
//                     <MenuItem value="">Select experience</MenuItem>
//                     <MenuItem value="none">No experience</MenuItem>
//                     <MenuItem value="1-2">1-2 years</MenuItem>
//                     <MenuItem value="3-5">3-5 years</MenuItem>
//                     <MenuItem value="5+">5+ years</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="City & State"
//                   value={applicationForm.location}
//                   onChange={(e) => handleFormChange('location', e.target.value)}
//                   variant="outlined"
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel>Availability</InputLabel>
//                   <Select
//                     value={applicationForm.availability}
//                     label="Availability"
//                     onChange={(e) => handleFormChange('availability', e.target.value)}
//                   >
//                     <MenuItem value="">Select availability</MenuItem>
//                     <MenuItem value="full-time">Full-time (40+ hours/week)</MenuItem>
//                     <MenuItem value="part-time">Part-time (20-30 hours/week)</MenuItem>
//                     <MenuItem value="weekends">Weekends only</MenuItem>
//                     <MenuItem value="flexible">Flexible schedule</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions sx={{ p: 3, gap: 2 }}>
//           <Button variant="outlined" onClick={closeApplicationDialog}>
//             Cancel
//           </Button>
//           {!formSubmitted && (
//             <Button
//               variant="contained"
//               onClick={handleSubmitApplication}
//               disabled={!applicationForm.fullName || !applicationForm.email || !applicationForm.phone}
//               sx={{ px: 4 }}
//             >
//               Submit Application
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default CleanerHome;



import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  Container,
  Card,
  CardContent,
  useTheme,
  Fade,
  Chip,
  Stack,
  alpha,
  Rating,
  Paper,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  InputAdornment,
  Slider,
  LinearProgress,
} from "@mui/material";
import { keyframes } from "@emotion/react";
import { Link } from "react-router-dom";
import {
  Work as WorkIcon,
  Schedule as ScheduleIcon,
  Payment as PaymentIcon,
  Star as StarIcon,
  CheckCircle as CheckCircleIcon,
  ArrowForward as ArrowForwardIcon,
  Close as CloseIcon,
  Chat as ChatIcon,
  Dashboard as DashboardIcon,
  Repeat as RepeatIcon,
  ExpandMore as ExpandMoreIcon,
  TrendingUp as TrendingUpIcon,
  AttachMoney as MoneyIcon,
  LocationOn as LocationIcon,
  Speed as SpeedIcon,
  Verified as VerifiedIcon,
  CompareArrows as CompareArrowsIcon,
} from "@mui/icons-material";

// Animations
const floatAnimation = keyframes`
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-8px) rotate(2deg); }
`;

const slideInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const slideInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const pulseRing = keyframes`
  0% {
    transform: scale(0.95);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.3;
  }
  100% {
    transform: scale(0.95);
    opacity: 0.7;
  }
`;

// Earnings Calculator Component
const EarningsCalculator = () => {
  const theme = useTheme();
  const [jobsPerWeek, setJobsPerWeek] = useState(3);
  const [ratePerJob, setRatePerJob] = useState(75);
  
  const weeklyEarnings = jobsPerWeek * ratePerJob;
  const monthlyEarnings = weeklyEarnings * 4;
  const yearlyEarnings = monthlyEarnings * 12;
  
  return (
    <Box sx={{ py: 8, bgcolor: alpha(theme.palette.primary.main, 0.02) }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "2rem", md: "2.5rem" },
                fontWeight: 800,
                mb: 2,
              }}
            >
              What Could You Earn?
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              See how much you can make with Airbnb turnover cleanings. Adjust the sliders to match your goals.
            </Typography>
            
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" fontWeight="600" gutterBottom>
                Number of jobs per week
              </Typography>
              <Slider
                value={jobsPerWeek}
                onChange={(e, val) => setJobsPerWeek(val)}
                min={1}
                max={10}
                step={1}
                marks={[
                  { value: 1, label: '1' },
                  { value: 3, label: '3' },
                  { value: 5, label: '5' },
                  { value: 7, label: '7' },
                  { value: 10, label: '10' },
                ]}
                sx={{ color: theme.palette.primary.main }}
              />
            </Box>
            
            <Box sx={{ mb: 4 }}>
              <Typography variant="subtitle2" fontWeight="600" gutterBottom>
                Average rate per cleaning
              </Typography>
              <TextField
                fullWidth
                type="number"
                value={ratePerJob}
                onChange={(e) => setRatePerJob(Number(e.target.value))}
                InputProps={{
                  startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  endAdornment: <InputAdornment position="end">per cleaning</InputAdornment>,
                }}
                sx={{ maxWidth: 250 }}
              />
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Paper
              elevation={0}
              sx={{
                p: 4,
                borderRadius: 4,
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                color: "white",
                textAlign: "center",
              }}
            >
              <Typography variant="h6" gutterBottom>Your Estimated Earnings</Typography>
              <Divider sx={{ my: 2, bgcolor: alpha(theme.palette.common.white, 0.2) }} />
              
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <Typography variant="h5" fontWeight="800">${weeklyEarnings}</Typography>
                  <Typography variant="caption">Per Week</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="h5" fontWeight="800">${monthlyEarnings}</Typography>
                  <Typography variant="caption">Per Month</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="h5" fontWeight="800">${yearlyEarnings}</Typography>
                  <Typography variant="caption">Per Year</Typography>
                </Grid>
              </Grid>
              
              <Divider sx={{ my: 2, bgcolor: alpha(theme.palette.common.white, 0.2) }} />
              
              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  💡 With repeat clients, your income becomes stable and predictable
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

// Comparison Section - FreshSweeper vs Alternatives
const ComparisonSection = () => {
  const theme = useTheme();
  
  const comparisons = [
    { feature: "Airbnb-specific turnover jobs", fresh: "✅", others: "⚠️" },
    { feature: "Repeat hosts & recurring income", fresh: "✅", others: "❌" },
    { feature: "Faster payments (weekly)", fresh: "✅", others: "⚠️" },
    { feature: "Set your own rates", fresh: "✅", others: "⚠️" },
    { feature: "No bidding wars", fresh: "✅", others: "❌" },
    { feature: "Less haggling over price", fresh: "✅", others: "❌" },
    { feature: "Background-checked hosts", fresh: "✅", others: "❌" },
    { feature: "In-app messaging & scheduling", fresh: "✅", others: "⚠️" },
  ];
  
  return (
    <Box sx={{ py: 8, bgcolor: theme.palette.background.paper }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem" },
              fontWeight: 800,
              mb: 2,
            }}
          >
            Why FreshSweeper is Different
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: "600px", mx: "auto" }}>
            Stop chasing one-time clients on Thumbtack, TaskRabbit, or Facebook groups
          </Typography>
        </Box>
        
        <Paper
          elevation={0}
          sx={{
            overflow: "hidden",
            borderRadius: 3,
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          }}
        >
          <Box sx={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`, bgcolor: alpha(theme.palette.primary.main, 0.02) }}>
                  <th style={{ textAlign: "left", padding: "16px", fontWeight: 700 }}>Feature</th>
                  <th style={{ textAlign: "center", padding: "16px", fontWeight: 700, color: theme.palette.primary.main }}>FreshSweeper</th>
                  <th style={{ textAlign: "center", padding: "16px", fontWeight: 700, color: theme.palette.text.secondary }}>Other Platforms</th>
                </tr>
              </thead>
              <tbody>
                {comparisons.map((item, idx) => (
                  <tr key={idx} style={{ borderBottom: idx < comparisons.length - 1 ? `1px solid ${alpha(theme.palette.divider, 0.1)}` : "none" }}>
                    <td style={{ padding: "16px", fontWeight: 500 }}>{item.feature}</td>
                    <td style={{ padding: "16px", textAlign: "center", fontSize: "1.2rem" }}>{item.fresh}</td>
                    <td style={{ padding: "16px", textAlign: "center", fontSize: "1.2rem", color: theme.palette.text.secondary }}>{item.others}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

// Hero Section with Improved Headline
const HeroSection = () => {
  const theme = useTheme();

  return (
    <Box sx={{ pt: { xs: 6, md: 8 }, pb: { xs: 6, md: 8 } }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={7}>
            <Fade in timeout={800}>
              <Box sx={{ animation: `${slideInLeft} 0.6s ease-out` }}>
                <Chip
                  label="🔥 High-Demand: Airbnb Turnover Jobs"
                  sx={{
                    mb: 3,
                    bgcolor: alpha(theme.palette.success.main, 0.1),
                    color: theme.palette.success.main,
                    fontWeight: 600,
                  }}
                />
                
                <Typography
                  variant="h1"
                  sx={{
                    fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
                    fontWeight: 800,
                    lineHeight: 1.1,
                    mb: 2,
                    color: theme.palette.text.primary,
                  }}
                >
                  Get More Airbnb Cleaning Jobs.
                  <Box component="span" sx={{ display: "block", color: theme.palette.primary.main }}>
                    Flexible Schedule. Reliable Pay.
                  </Box>
                </Typography>

                <Typography
                  variant="h6"
                  sx={{
                    mb: 4,
                    fontSize: "1.1rem",
                    lineHeight: 1.6,
                    color: theme.palette.text.secondary,
                  }}
                >
                  Join the platform built specifically for short-term rental cleanings. Get discovered by hosts 
                  who need reliable turnover cleaners. Choose your rates, set your schedule, get paid faster.
                </Typography>

                <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                  <Button
                    variant="contained"
                    size="large"
                    startIcon={<ArrowForwardIcon />}
                    sx={{
                      px: 4,
                      py: 1.5,
                      fontSize: "1rem",
                      borderRadius: "50px",
                      fontWeight: 700,
                      "&:hover": { transform: "translateY(-2px)" },
                      transition: "all 0.3s ease",
                    }}
                  >
                    Join Free
                  </Button>
                  <Button
                    variant="outlined"
                    size="large"
                    sx={{
                      px: 4,
                      py: 1.5,
                      fontSize: "1rem",
                      borderRadius: "50px",
                      fontWeight: 600,
                      "&:hover": { transform: "translateY(-2px)" },
                      transition: "all 0.3s ease",
                    }}
                  >
                    See Jobs Near Me
                  </Button>
                  <Button
                    variant="text"
                    size="large"
                    sx={{
                      px: 3,
                      py: 1.5,
                      fontSize: "0.95rem",
                      borderRadius: "50px",
                      fontWeight: 500,
                    }}
                  >
                    Create Cleaner Profile
                  </Button>
                </Stack>

                <Box sx={{ display: "flex", gap: 3, mt: 4, flexWrap: "wrap" }}>
                  <Chip icon={<CheckCircleIcon />} label="Free signup" variant="outlined" />
                  <Chip icon={<ScheduleIcon />} label="Choose your rates" variant="outlined" />
                  <Chip icon={<MoneyIcon />} label="Weekly payouts" variant="outlined" />
                  <Chip icon={<RepeatIcon />} label="Repeat hosts" variant="outlined" />
                </Box>
              </Box>
            </Fade>
          </Grid>
          
          <Grid item xs={12} md={5}>
            <Fade in timeout={1000}>
              <Box sx={{ animation: `${slideInRight} 0.6s ease-out`, position: "relative" }}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: 280, sm: 380, md: 420 },
                    height: { xs: 280, sm: 380, md: 420 },
                    borderRadius: "50%",
                    border: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                    animation: `${pulseRing} 3s ease-in-out infinite`,
                  }}
                />
                
                <Box
                  sx={{
                    position: "relative",
                    width: { xs: 260, sm: 360, md: 400 },
                    height: { xs: 260, sm: 360, md: 400 },
                    mx: "auto",
                    borderRadius: "50%",
                    overflow: "hidden",
                    boxShadow: `0 30px 50px ${alpha(theme.palette.primary.main, 0.2)}`,
                    animation: `${floatAnimation} 4s ease-in-out infinite`,
                    border: `4px solid ${theme.palette.primary.main}`,
                  }}
                >
                  <Box
                    component="img"
                    src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=500&h=500&fit=crop"
                    alt="Professional cleaner"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                  
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      height: "40%",
                      background: `linear-gradient(to top, ${alpha(theme.palette.primary.main, 0.3)}, transparent)`,
                    }}
                  />
                </Box>

                <Paper
                  elevation={0}
                  sx={{
                    position: "absolute",
                    bottom: 10,
                    right: { xs: 10, sm: 20, md: 40 },
                    p: 1.5,
                    borderRadius: 3,
                    bgcolor: "white",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    zIndex: 2,
                  }}
                >
                  <MoneyIcon sx={{ color: theme.palette.success.main, fontSize: 20 }} />
                  <Typography variant="body2" fontWeight="600">$35-75 per cleaning</Typography>
                </Paper>
              </Box>
            </Fade>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

// Sticky Mobile CTA
const MobileStickyCTA = () => {
  const theme = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        display: { xs: isVisible ? "block" : "none", md: "none" },
        bgcolor: "white",
        boxShadow: "0 -4px 20px rgba(0,0,0,0.1)",
        p: 2,
        borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
      }}
    >
      <Container maxWidth="sm">
        <Button
          fullWidth
          variant="contained"
          size="large"
          startIcon={<ArrowForwardIcon />}
          sx={{
            borderRadius: "50px",
            py: 1.5,
            fontWeight: 700,
          }}
        >
          Join Free - Create Profile
        </Button>
      </Container>
    </Box>
  );
};

// Rest of the sections remain similar but with improved copy
const PainSection = () => {
  const theme = useTheme();

  const pains = [
    "Inconsistent Airbnb bookings",
    "One-time customers only",
    "Last-minute cancellations",
    "Wasting time bidding on jobs",
    "Haggling over prices",
    "Getting lost in Facebook groups",
  ];

  return (
    <Box sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Fade in timeout={800}>
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: "2rem", md: "2.5rem" },
                    fontWeight: 800,
                    mb: 3,
                  }}
                >
                  Tired of chasing one-time clients?
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 4 }}>
                  {pains.map((pain, idx) => (
                    <Chip
                      key={idx}
                      label={pain}
                      icon={<CloseIcon sx={{ fontSize: 16 }} />}
                      sx={{
                        justifyContent: "flex-start",
                        width: "auto",
                        bgcolor: alpha(theme.palette.error.main, 0.05),
                        color: theme.palette.error.main,
                        py: 2,
                        px: 2,
                        '& .MuiChip-label': { fontWeight: 500 },
                      }}
                    />
                  ))}
                </Box>
                <Typography variant="h5" fontWeight="700" color="primary.main">
                  There's a smarter way to grow.
                </Typography>
              </Box>
            </Fade>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=500&h=400&fit=crop"
              alt="Frustrated cleaner"
              sx={{ width: "100%", borderRadius: "24px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)" }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

const SolutionSection = () => {
  const theme = useTheme();

  return (
    <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Chip
            label="The Solution"
            sx={{ mb: 2, bgcolor: alpha(theme.palette.success.main, 0.1), color: theme.palette.success.main }}
          />
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem" },
              fontWeight: 800,
              mb: 2,
            }}
          >
            Let jobs come to you.
          </Typography>
          <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
            FreshSweeper connects cleaners with Airbnb hosts who need reliable recurring turnover cleanings.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {[
            { icon: "🔍", title: "Find More Jobs", desc: "Get discovered by hosts looking for trusted turnover cleaners nearby." },
            { icon: "🔄", title: "Build Repeat Clients", desc: "Turn one booking into weekly or monthly recurring work with the same hosts." },
            { icon: "💰", title: "Choose Your Rates", desc: "Set your own prices. No bidding wars. No haggling." },
            { icon: "⚡", title: "Faster Payments", desc: "Get paid weekly. No chasing clients for payment." },
            { icon: "📋", title: "Stay Organized", desc: "Manage schedules, messages, payouts, and jobs in one place." },
            { icon: "⭐", title: "Build Your Reputation", desc: "Get rated by hosts and become a preferred cleaner." },
          ].map((item, idx) => (
            <Grid item xs={12} sm={6} md={4} key={idx}>
              <Zoom timeout={400 + idx * 100}>
                <Card sx={{ p: 3, textAlign: "center", height: "100%", borderRadius: 3 }}>
                  <Box sx={{ fontSize: 48, mb: 2 }}>{item.icon}</Box>
                  <Typography variant="h6" fontWeight="800" gutterBottom>{item.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{item.desc}</Typography>
                </Card>
              </Zoom>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

// Core Features Section with Airbnb-specific terms
const CoreFeaturesSection = () => {
  const theme = useTheme();

  const features = [
    { icon: <ScheduleIcon />, title: "Flexible Scheduling", desc: "Accept only the Airbnb turnover jobs that fit your calendar." },
    { icon: <MoneyIcon />, title: "Set Your Rates", desc: "Choose what you charge per cleaning. No bidding against other cleaners." },
    { icon: <VerifiedIcon />, title: "Verified Hosts", desc: "All hosts are background-checked. No risky clients." },
    { icon: <RepeatIcon />, title: "Recurring Work", desc: "Hosts can rebook you for every guest turnover. Stable monthly income." },
    { icon: <ChatIcon />, title: "In-App Messaging", desc: "Communicate clearly with hosts without messy texts." },
    { icon: <DashboardIcon />, title: "Job Tracking", desc: "See upcoming, active, and completed vacation rental cleanings." },
  ];

  return (
    <Box sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem" },
              fontWeight: 800,
              mb: 2,
            }}
          >
            Everything You Need to Grow
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: "600px", mx: "auto" }}>
            Built specifically for short-term rental and vacation rental cleaning professionals
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {features.map((feature, idx) => (
            <Grid item xs={12} sm={6} md={4} key={idx}>
              <Fade in timeout={400 + idx * 100}>
                <Card sx={{ p: 3, height: "100%", borderRadius: 3 }}>
                  <Box sx={{ width: 48, height: 48, borderRadius: "12px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", mb: 2, color: theme.palette.primary.main }}>
                    {feature.icon}
                  </Box>
                  <Typography variant="h6" fontWeight="700" gutterBottom>{feature.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{feature.desc}</Typography>
                </Card>
              </Fade>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

// Why Cleaners Join Section
const WhyCleanersJoin = () => {
  const theme = useTheme();

  const reasons = [
    "More consistent Airbnb turnover jobs",
    "Flexible schedule - work when you want",
    "Repeat clients = stable monthly income",
    "Less time marketing yourself on Facebook/Craigslist",
    "No bidding wars or haggling over price",
    "Faster payments - get paid weekly",
    "Professional growth and ratings",
    "Choose your own service area",
  ];

  return (
    <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "2rem", md: "2.5rem" },
                fontWeight: 800,
                mb: 3,
              }}
            >
              Why Cleaners Choose FreshSweeper
            </Typography>
            <Grid container spacing={2}>
              {reasons.map((reason, idx) => (
                <Grid item xs={12} sm={6} key={idx}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <CheckCircleIcon sx={{ color: theme.palette.success.main, fontSize: 20 }} />
                    <Typography variant="body1">{reason}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=500&h=400&fit=crop"
              alt="Happy cleaner"
              sx={{ width: "100%", borderRadius: "24px", boxShadow: "0 20px 40px rgba(0,0,0,0.1)" }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

// How It Works Section
const HowItWorks = () => {
  const theme = useTheme();

  const steps = [
    { number: "1", title: "Create your free cleaner profile", icon: "📝", time: "5 minutes" },
    { number: "2", title: "Set your rates and availability", icon: "💰", time: "Choose what you earn" },
    { number: "3", title: "Get matched with Airbnb hosts", icon: "🤝", time: "Jobs come to you" },
    { number: "4", title: "Complete jobs, get paid weekly", icon: "💵", time: "Repeat clients = stable income" },
  ];

  return (
    <Box sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Chip
            label="Simple Process"
            sx={{ mb: 2, bgcolor: alpha(theme.palette.info.main, 0.1), color: theme.palette.info.main }}
          />
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem" },
              fontWeight: 800,
              mb: 2,
            }}
          >
            Start Earning in Minutes
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {steps.map((step, idx) => (
            <Grid item xs={12} sm={6} md={3} key={idx}>
              <Zoom timeout={400 + idx * 100}>
                <Card sx={{ p: 3, textAlign: "center", height: "100%", borderRadius: 3 }}>
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      borderRadius: "20px",
                      bgcolor: alpha(theme.palette.primary.main, 0.1),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1.8rem",
                      mx: "auto",
                      mb: 2,
                      position: "relative",
                    }}
                  >
                    <Typography variant="caption" sx={{ position: "absolute", top: -8, right: -8, bgcolor: theme.palette.primary.main, color: "white", width: 24, height: 24, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.7rem", fontWeight: "bold" }}>
                      {step.number}
                    </Typography>
                    {step.icon}
                  </Box>
                  <Typography variant="body2" fontWeight="600" gutterBottom>{step.title}</Typography>
                  <Typography variant="caption" color="text.secondary">{step.time}</Typography>
                </Card>
              </Zoom>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

// Testimonials Section
const TestimonialsSection = () => {
  const theme = useTheme();

  const testimonials = [
    { name: "Maria R.", text: "I started getting repeat Airbnb clients within my first week. Now I have consistent monthly income.", rating: 5, role: "Professional Cleaner", location: "Miami, FL" },
    { name: "James W.", text: "Way easier than chasing random customers on Facebook. FreshSweeper brings the jobs to me.", rating: 5, role: "Cleaning Team Lead", location: "Austin, TX" },
    { name: "Sarah C.", text: "I set my own rates and work when I want. Finally, a platform that respects cleaners.", rating: 5, role: "Solo Cleaner", location: "San Diego, CA" },
  ];

  return (
    <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Chip
            label="Real Cleaners, Real Results"
            sx={{ mb: 2, bgcolor: alpha(theme.palette.secondary.main, 0.1), color: theme.palette.secondary.main }}
          />
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem" },
              fontWeight: 800,
            }}
          >
            Join 500+ Cleaners Earning More
          </Typography>
        </Box>
        <Grid container spacing={4}>
          {testimonials.map((testimonial, idx) => (
            <Grid item xs={12} md={4} key={idx}>
              <Fade in timeout={500 + idx * 150}>
                <Card sx={{ p: 4, height: "100%", borderRadius: 3 }}>
                  <Rating value={testimonial.rating} readOnly sx={{ mb: 2 }} />
                  <QuoteIcon sx={{ fontSize: 32, color: alpha(theme.palette.primary.main, 0.2), mb: 2 }} />
                  <Typography variant="body1" sx={{ fontStyle: "italic", mb: 2 }}>"{testimonial.text}"</Typography>
                  <Typography variant="subtitle2" fontWeight="700">{testimonial.name}</Typography>
                  <Typography variant="caption" color="text.secondary">{testimonial.role} • {testimonial.location}</Typography>
                </Card>
              </Fade>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

// FAQ Section
const FAQSection = () => {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(null);

  const faqs = [
    { q: "How much does it cost to join?", a: "Creating a cleaner profile is completely free. No monthly fees. You only pay a small platform fee when you complete jobs." },
    { q: "What are Airbnb turnover jobs?", a: "Turnover cleanings happen between guest stays. Hosts need reliable cleaners to prepare their properties for incoming guests. These are recurring, predictable jobs." },
    { q: "Can I choose my own rates?", a: "Yes! You set your own rates per cleaning. No bidding wars. No haggling. Hosts see your rates and choose you." },
    { q: "How do I get paid?", a: "Payments are processed weekly via direct deposit. No chasing clients for payment." },
    { q: "Do I need Airbnb experience?", a: "No. Reliable residential cleaners with attention to detail can succeed. We provide training on what hosts expect." },
    { q: "How is this different from Thumbtack or TaskRabbit?", a: "FreshSweeper is built specifically for short-term rental cleanings. You get repeat hosts, stable income, and no bidding wars." },
  ];

  return (
    <Box sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Grid container spacing={6}>
          <Grid item xs={12} md={5}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "2rem", md: "2.5rem" },
                fontWeight: 800,
                mb: 2,
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Everything you need to know about becoming a FreshSweeper cleaner.
            </Typography>
          </Grid>
          <Grid item xs={12} md={7}>
            <Stack spacing={2}>
              {faqs.map((faq, idx) => (
                <Accordion
                  key={idx}
                  expanded={expanded === idx}
                  onChange={() => setExpanded(expanded === idx ? null : idx)}
                  sx={{ borderRadius: 2, '&:before': { display: 'none' } }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1" fontWeight="600">{faq.q}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" color="text.secondary">{faq.a}</Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

// CTA Section with multiple options
const CTASection = () => {
  const theme = useTheme();

  return (
    <Box sx={{ py: 12, background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)` }}>
      <Container maxWidth="md">
        <Box sx={{ textAlign: "center", color: "white" }}>
          <MoneyIcon sx={{ fontSize: 56, mb: 2, opacity: 0.9 }} />
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem" },
              fontWeight: 800,
              mb: 2,
            }}
          >
            Ready for More Airbnb Cleaning Jobs?
          </Typography>
          <Typography variant="h6" sx={{ mb: 4, opacity: 0.9 }}>
            Join 500+ cleaners who have found reliable income with short-term rental cleanings.
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
            <Button
              variant="contained"
              size="large"
              startIcon={<ArrowForwardIcon />}
              sx={{
                bgcolor: "white",
                color: theme.palette.primary.main,
                borderRadius: "50px",
                px: 5,
                py: 1.5,
                fontWeight: 700,
                "&:hover": { bgcolor: alpha(theme.palette.common.white, 0.9), transform: "translateY(-2px)" },
              }}
            >
              Join Free - Create Profile
            </Button>
            <Button
              variant="outlined"
              size="large"
              sx={{
                borderColor: "white",
                color: "white",
                borderRadius: "50px",
                px: 5,
                py: 1.5,
                fontWeight: 600,
                "&:hover": { bgcolor: alpha(theme.palette.common.white, 0.1), transform: "translateY(-2px)" },
              }}
            >
              See Jobs Near Me
            </Button>
          </Stack>
          <Typography variant="body2" sx={{ mt: 4, opacity: 0.7 }}>
            Free to join • Set your own rates • No monthly fees
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

// Main Component
const CleanerHome = () => {
  return (
    <Box sx={{ overflow: "hidden", bgcolor: "white" }}>
      <HeroSection />
      <SocialProofBar />
      <PainSection />
      <SolutionSection />
      <EarningsCalculator />
      <ComparisonSection />
      <CoreFeaturesSection />
      <WhyCleanersJoin />
      <HowItWorks />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <MobileStickyCTA />
    </Box>
  );
};

// SocialProofBar component (keep as is from original)
const SocialProofBar = () => {
  const theme = useTheme();

  return (
    <Box sx={{ py: 3, bgcolor: alpha(theme.palette.primary.main, 0.03), borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`, borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
      <Container maxWidth="lg">
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2, flexWrap: "wrap" }}>
          <Typography variant="body2" color="text.secondary">Trusted by</Typography>
          <Box sx={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
            {["500+ Active Cleaners", "2,500+ Jobs/Month", "4.9★ Cleaner Rating", "$35-75 per cleaning"].map((item, idx) => (
              <Chip key={idx} label={item} size="small" sx={{ bgcolor: "white" }} />
            ))}
          </Box>
          <Typography variant="body2" color="text.secondary">earning reliable income</Typography>
        </Box>
      </Container>
    </Box>
  );
};

// QuoteIcon component
const QuoteIcon = ({ sx }) => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" style={sx}>
    <path d="M6,17h3l2-4V7H5v6h3L6,17z M14,17h3l2-4V7h-6v6h3L14,17z"/>
  </svg>
);

// Zoom component
const Zoom = ({ children, timeout }) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), timeout);
    return () => clearTimeout(timer);
  }, [timeout]);
  return (
    <Box sx={{ opacity: isVisible ? 1 : 0, transform: isVisible ? 'scale(1)' : 'scale(0.95)', transition: 'all 0.3s ease' }}>
      {children}
    </Box>
  );
};

export default CleanerHome;